<template>
  <vs-chip class="mr-2 rounded" :color="color">
    <strong>{{ title }}</strong>
  </vs-chip>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
